import React, { type KeyboardEvent, useState } from 'react'
import { Badge, Form } from 'react-bootstrap'

interface ScopesTagInputProps {
  scopes: string[]
  onChange: (scopes: string[]) => void
  disabled?: boolean
}

export const ScopesTagInput: React.FC<ScopesTagInputProps> = ({ scopes, onChange, disabled = false }) => {
  const [draft, setDraft] = useState<string>('')

  const addDraft = () => {
    const scope = draft.trim()
    if (scope !== '' && !scopes.includes(scope)) {
      onChange([...scopes, scope])
    }
    setDraft('')
  }

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' || event.key === ',') {
      event.preventDefault()
      addDraft()
    }
  }

  return (
    <Form.Group controlId='custom-integration-scopes'>
      <Form.Label className='paragraph-small mb-1'>
        OAuth scopes <span className='zocks-text-gray-600'>(optional)</span>
      </Form.Label>
      {scopes.length ? (
        <div className='d-flex flex-wrap gap-2 mb-2'>
          {scopes.map((scope) => (
            <Badge key={scope} bg='' className='d-flex align-items-center gap-1 zocks-bg-color-gray-100 zocks-text-gray-900 fw-500'>
              {scope}
              {disabled ? null : (
                <button
                  type='button'
                  className='btn btn-link p-0 lh-1 zocks-text-gray-600'
                  aria-label={`Remove scope ${scope}`}
                  onClick={() => onChange(scopes.filter((s) => s !== scope))}
                >
                  <i className='bi bi-x' />
                </button>
              )}
            </Badge>
          ))}
        </div>
      ) : null}
      <Form.Control
        type='text'
        placeholder='Add scope and press enter'
        value={draft}
        disabled={disabled}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={addDraft}
      />
      <Form.Text className='paragraph-extra-small zocks-text-gray-600'>Scopes to request during authorization. Press Enter to add each scope.</Form.Text>
    </Form.Group>
  )
}
